import { Form } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import DinamicForm from 'modules/dinamic-form'
import { CustomInputTypes } from 'modules/dinamic-form/custom-inputs/custom-input/CustomInput.enum'
import React from 'react'

interface IProps extends FormComponentProps {
  fields: any
  callback: (data: any) => void
  validate: Array<any> | string
}

const QuickFilters: React.FC<IProps> = ({ form, fields, callback, validate }) => {
  const { getFieldsValue } = form

  const types: any = {
    SelectInput: CustomInputTypes.SelectInput,
    TextInput: CustomInputTypes.TextInput,
    DateInput: CustomInputTypes.DateInput,
    SwitchInput: CustomInputTypes.SwitchInput,
  }

  const validateKeys = (keys: any, obj: any) => {
    return keys.every((key: any) => obj[key] !== undefined)
  }

  const filtersFields = fields.map((item: any) => ({
    ...item,
    type: types[item?.type],
    inputProps: {
      ...item?.inputProps,
      showSearch: true,
      filterOption: (input: any, option: any) => option?.props?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      onChange: (value: any) => {
        setTimeout(() => {
          if (!validate) {
            if (validateKeys(Object.keys(getFieldsValue()), getFieldsValue())) {
              handleSubmit()
            }
            return
          }

          if (validateKeys(validate, getFieldsValue())) {
            handleSubmit()
            return
          }

          if (item?.inputProps?.onChange) {
            item?.inputProps?.onChange(value)
          }
        })
      },
    },
  }))

  const handleSubmit = () => {
    form.validateFields(async (err: any, values: any) => {
      if (!err) {
        callback(values)
      }
    })
  }

  return (
    <div>
      <DinamicForm customInputs={true} fields={filtersFields} fieldsPerRow={3} form={form} prefixTranslate={'prefix'} />
    </div>
  )
}

export default Form.create<IProps>({
  name: 'QuickFiltersForm',
})(QuickFilters)
